// @ts-nocheck
/* ==========================================================================
   Cyber Monday ARGENTINA — captação de lead (Shopify + HubSpot em um único envio)
   Baseado em hot-sale-form.js (LP Hot Sale) e hero-bf-form.js (LP Black Friday).
   Campanha exclusiva da loja Argentina: telefone sempre +54 9, nacionalidade
   vem do Liquid ("Argentina").

   Fluxo do submit:
   1) valida os campos (celular argentino: código de área + número = 10 dígitos);
   2) preenche os campos ocultos que o form de cliente da Shopify recebe;
   3) posta na HubSpot Forms Submission API v3 (keepalive, timeout curto);
   4) libera o envio nativo com form.requestSubmit(), que dispara um evento de
      submit real — necessário para a proteção hCaptcha da Shopify injetar o
      token (form.submit() pula esse evento e gera "Missing CAPTCHA token").
   ========================================================================== */
(function () {
  'use strict';

  var HUBSPOT_TIMEOUT_MS = 4000;

  // Celular da Argentina: DDI 54 + "9" de celular; código de área + número = 10 dígitos.
  // O campo mostra SEMPRE o número nacional (10 dígitos, ex.: 11 2345-6789) — o que
  // não cabe nisso é removido na hora: "0" do código de área, "+54", "9" e "15".
  var AR_DIAL = '54';
  var AR_MOBILE = '9';
  var AR_LEN = 10;
  // Códigos de área de 3 dígitos (o resto que começa com 2/3 tem 4 dígitos; 11 = Buenos Aires).
  var AR_AREA3 = ['220', '221', '223', '230', '236', '237', '249', '260', '261', '263', '264', '266',
    '280', '291', '294', '297', '298', '299', '336', '341', '342', '343', '345', '348', '351', '353',
    '358', '362', '364', '370', '376', '379', '380', '381', '383', '385', '387', '388'];
  // Começos válidos de código de área na Argentina.
  var AR_AREA_START = ['11', '22', '23', '24', '26', '28', '29', '33', '34', '35', '36', '37', '38'];

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var UTM_STORAGE_KEY = 'madesa_cyber_utm';
  // Marca que o lead desta sessão já foi enviado à HubSpot (ver o bloco "Shopify recusou" no initForm).
  var HS_SENT_KEY = 'madesa_cyber_hs_sent';

  // ---------------------------------------------------------------- helpers

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function arAreaLength(d) {
    if (d.slice(0, 2) === '11') return 2;
    if (AR_AREA3.indexOf(d.slice(0, 3)) > -1) return 3;
    return 4;
  }

  // Devolve só os dígitos nacionais (no máximo 10). Enquanto a pessoa digita "+5"/"+54",
  // devolve { pending } para não apagar o que ela está escrevendo.
  function arNormalize(value) {
    var d = (value || '').replace(/\D/g, '').replace(/^0+/, '');
    // Código de área nunca começa com 5: "5…" é o DDI 54.
    if (d.charAt(0) === '5') {
      if (d === '5' || d === '54' || d === '549') return { pending: d };
      if (d.indexOf(AR_DIAL) === 0) d = d.slice(AR_DIAL.length).replace(/^0+/, '');
    }
    // Código de área nunca começa com 9: "9…" é o prefixo de celular.
    if (d.charAt(0) === AR_MOBILE) d = d.slice(1).replace(/^0+/, '');
    // "15" logo depois do código de área é o prefixo de celular local.
    var L = arAreaLength(d);
    if (d.length >= L + 2 && d.substr(L, 2) === '15') d = d.slice(0, L) + d.slice(L + 2);
    return { digits: d.slice(0, AR_LEN) };
  }

  function arFormat(value) {
    var n = arNormalize(value);
    if (n.pending) return '+' + n.pending.replace(/^54(9)$/, '54 $1');
    var d = n.digits;
    if (d.length <= 2) return d;
    var L = arAreaLength(d);
    if (d.length <= L) return d;
    var rest = d.slice(L);
    var first = L === 2 ? 4 : L === 3 ? 3 : 2; // 11 2345-6789 · 351 234-5678 · 2966 12-3456
    return d.slice(0, L) + ' ' + (rest.length > first ? rest.slice(0, first) + '-' + rest.slice(first) : rest);
  }

  // '' = válido · 'length' = faltam dígitos · 'area' = código de área inexistente
  function arPhoneError(value) {
    var n = arNormalize(value);
    var d = n.digits || '';
    if (d.length !== AR_LEN) return 'length';
    if (AR_AREA_START.indexOf(d.slice(0, 2)) === -1) return 'area';
    if (d.charAt(arAreaLength(d)) === '0') return 'length'; // número local não começa com 0
    return '';
  }

  function arE164(value) {
    var d = arNormalize(value).digits || '';
    return d ? '+' + AR_DIAL + AR_MOBILE + d : '';
  }

  function splitFullName(fullName) {
    var parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return { firstname: '', lastname: '' };
    return { firstname: parts[0], lastname: parts.slice(1).join(' ') };
  }

  function getHubspotUtk() {
    var match = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return match ? decodeURIComponent(match[2]) : '';
  }

  function readUtmsFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var utms = {};
    UTM_KEYS.forEach(function (key) {
      var value = (params.get(key) || '').trim();
      if (value) utms[key] = value;
    });
    return utms;
  }

  // Guarda as UTMs da primeira URL da sessão: se a pessoa navegar antes de
  // enviar, a atribuição não se perde.
  function persistUtms() {
    var fromUrl = readUtmsFromUrl();
    if (!Object.keys(fromUrl).length) return;
    try { sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromUrl)); } catch (e) {}
  }

  function getUtms() {
    var fromUrl = readUtmsFromUrl();
    if (Object.keys(fromUrl).length) return fromUrl;
    try {
      var stored = sessionStorage.getItem(UTM_STORAGE_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }

  function field(name, value) {
    return { objectTypeId: '0-1', name: name, value: String(value) };
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // ------------------------------------------------------------------ form

  function initForm(form) {
    if (!form || form.dataset.cyberInit === 'true') return;
    form.dataset.cyberInit = 'true';

    var STR = {};
    var i18nEl = form.querySelector('[data-cyber-i18n]');
    if (i18nEl) {
      try { STR = JSON.parse(i18nEl.textContent); } catch (e) { STR = {}; }
    }

    var nameInput = form.querySelector('[data-cyber-name]');
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var phoneInput = form.querySelector('[data-cyber-phone]');
    var consentInput = form.querySelector('[data-cyber-consent]');
    var statusEl = form.querySelector('[data-cyber-status]');
    var submitBtn = form.querySelector('.cyber-form__button');
    var submitLabel = form.querySelector('[data-cyber-submit-label]');
    var submitLabelDefault = submitLabel ? submitLabel.textContent.trim() : '';

    var firstNameField = form.querySelector('input[name="contact[first_name]"]');
    var lastNameField = form.querySelector('input[name="contact[last_name]"]');
    var phoneField = form.querySelector('input[name="contact[phone]"]');

    var consentRequired = !!(consentInput && consentInput.dataset.required === 'true');

    var hsPortalId = (form.dataset.hsPortalId || '').trim();
    var hsFormId = (form.dataset.hsFormId || '').trim();
    var hsPhoneField = (form.dataset.hsPhoneField || 'phone').trim();
    var hsNacionalidade = (form.dataset.hsNacionalidade || '').trim();
    var hsOrigem = (form.dataset.hsOrigemStaging || '').trim();

    var submitting = false;

    // Se a Shopify recusar o cadastro (ex.: telefone já usado por outro cliente),
    // o lead já está na HubSpot: leva a pessoa para a página de sucesso em vez
    // de travá-la num erro que ela não consegue resolver.
    var shopifyErrors = form.querySelector('[data-cyber-shopify-errors]');
    var successUrl = (form.dataset.successUrl || '').trim();
    if (shopifyErrors && successUrl) {
      var sent = '';
      try { sent = sessionStorage.getItem(HS_SENT_KEY) || ''; } catch (e) {}
      if (sent === '1') {
        console.warn('[cyber] Shopify recusou o cadastro; lead já enviado à HubSpot.', shopifyErrors.textContent.trim());
        try { sessionStorage.removeItem(HS_SENT_KEY); } catch (e) {}
        window.location.replace(successUrl);
        return;
      }
      shopifyErrors.hidden = false;
    }

    function showStatus(message) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.hidden = !message;
    }

    function markInvalid(input, invalid) {
      if (input) input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    }

    function setSubmitting(state) {
      submitting = state;
      if (submitBtn) submitBtn.disabled = state;
      if (submitLabel) submitLabel.textContent = state ? STR.submitLoading || 'Enviando...' : submitLabelDefault;
    }

    function validate() {
      var nome = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';

      [nameInput, emailInput, phoneInput, consentInput].forEach(function (el) { markInvalid(el, false); });

      if ((nameInput && !nome) || (emailInput && !email) || (phoneInput && !phone)) {
        markInvalid(nameInput, nameInput && !nome);
        markInvalid(emailInput, emailInput && !email);
        markInvalid(phoneInput, phoneInput && !phone);
        return STR.validationRequired || 'Completa todos los campos.';
      }
      if (nameInput && nome.length < 3) {
        markInvalid(nameInput, true);
        return STR.validationName || '';
      }
      if (emailInput && !isValidEmail(email)) {
        markInvalid(emailInput, true);
        return STR.validationEmail || '';
      }
      var phoneError = phoneInput ? arPhoneError(phone) : '';
      if (phoneError) {
        markInvalid(phoneInput, true);
        return phoneError === 'area'
          ? STR.validationPhoneArea || 'Revisá el código de área (ej.: 11, 351, 2966).'
          : STR.validationPhone || '';
      }
      if (consentRequired && !consentInput.checked) {
        markInvalid(consentInput, true);
        return STR.validationConsent || '';
      }
      return '';
    }

    function buildHubSpotFields(data) {
      var fields = [
        field('email', data.email),
        field('firstname', data.firstname),
      ];
      if (data.lastname) fields.push(field('lastname', data.lastname));
      if (data.phoneDigits) fields.push(field(hsPhoneField, data.phoneDigits));
      // Só envia o consentimento quando marcado: "false" apagaria um opt-in anterior.
      if (!consentInput || consentInput.checked) fields.push(field('madesa_email_consent', 'true'));
      if (hsNacionalidade) fields.push(field('nacionalidade', hsNacionalidade));
      if (hsOrigem) {
        fields.push(field('origem_de_cadastro_staging', hsOrigem));
        fields.push(field('origem_de_cadastro__crm__staging', hsOrigem));
        // Fuente de registro (LATAM) Staging — mesmo valor das origens acima.
        fields.push(field('fuente_de_registro__mexico_', hsOrigem));
      }
      // UTM vazia não entra: string vazia apagaria a atribuição anterior.
      var utms = getUtms();
      UTM_KEYS.forEach(function (key) {
        if (utms[key]) fields.push(field(key, utms[key]));
      });
      return fields;
    }

    // Resolve sempre: uma falha na HubSpot não pode impedir a gravação na Shopify.
    function sendToHubSpot(fields) {
      if (!hsPortalId || !hsFormId) return Promise.resolve();

      var context = { pageUri: window.location.href, pageName: document.title || window.location.pathname };
      var hutk = getHubspotUtk();
      if (hutk) context.hutk = hutk; // hutk vazio faz a API rejeitar

      return fetch(
        'https://api.hsforms.com/submissions/v3/integration/submit/' + hsPortalId + '/' + hsFormId,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ fields: fields, context: context }),
          keepalive: true,
        }
      )
        .then(function (res) {
          if (res.ok) {
            try { sessionStorage.setItem(HS_SENT_KEY, '1'); } catch (e) {}
            return;
          }
          return res.json().catch(function () { return null; }).then(function (body) {
            console.error('[cyber] HubSpot recusou o envio', res.status, body);
          });
        })
        .catch(function (err) {
          console.error('[cyber] Falha ao enviar para a HubSpot', err);
        });
    }

    function releaseNativeSubmit() {
      form.dataset.cyberReady = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        nativeFormSubmit.call(form);
      }
    }

    // ----- listeners (registrados uma única vez)

    if (phoneInput) {
      // Folga só para colar/autocompletar "+54 9 11 …"; o que fica no campo são 10 dígitos.
      phoneInput.setAttribute('maxlength', '24');
      var applyPhoneMask = function () {
        var formatted = arFormat(phoneInput.value);
        if (phoneInput.value !== formatted) phoneInput.value = formatted;
      };
      // input = digitação/colagem · change/blur = preenchimento automático do navegador
      ['input', 'change', 'blur'].forEach(function (evt) { phoneInput.addEventListener(evt, applyPhoneMask); });
      applyPhoneMask();
    }

    [nameInput, emailInput, phoneInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') markInvalid(input, false);
      });
    });

    if (consentInput) {
      consentInput.addEventListener('change', function () { markInvalid(consentInput, false); });
    }

    form.addEventListener('submit', function (event) {
      // 2ª passada (requestSubmit): deixa a Shopify e o hCaptcha seguirem.
      if (form.dataset.cyberReady === 'true') return;

      event.preventDefault();
      if (submitting) return;

      var error = validate();
      if (error) {
        showStatus(error);
        return;
      }
      showStatus('');

      var nome = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var phoneE164 = phoneInput ? arE164(phoneInput.value) : '';
      var names = splitFullName(nome);

      // Campos que a Shopify grava.
      if (firstNameField) firstNameField.value = names.firstname || nome;
      if (lastNameField) lastNameField.value = names.lastname;
      if (phoneField) phoneField.value = phoneE164;

      setSubmitting(true);

      var hubspot = sendToHubSpot(
        buildHubSpotFields({
          email: email,
          firstname: names.firstname || nome,
          lastname: names.lastname,
          phoneDigits: phoneE164.replace(/\D/g, ''),
        })
      );

      // setTimeout: se a HubSpot resolver na hora (ex.: Form ID vazio), o
      // requestSubmit() ainda cairia dentro do evento de submit atual e o
      // navegador o ignoraria — o envio para a Shopify nunca aconteceria.
      Promise.race([hubspot, wait(HUBSPOT_TIMEOUT_MS)]).then(function () {
        setTimeout(releaseNativeSubmit, 0);
      });
    });

    // Se o navegador restaurar a página pelo botão "voltar", reabilita o form.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        form.dataset.cyberReady = 'false';
        setSubmitting(false);
      }
    });
  }

  // Scripts de terceiros (ex.: Meta Pixel fbevents.js) chamam form.submit()
  // direto, o que pula o evento de submit, a validação e a HubSpot: a Shopify
  // recebe o telefone inválido e recarrega a página com ?form_type=customer.
  // Nos formulários da LP, form.submit() só passa depois do nosso fluxo
  // (data-cyber-ready="true"); nos demais formulários da loja nada muda.
  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  function guardNativeSubmit() {
    if (HTMLFormElement.prototype.submit.__cyberGuard) return;
    var guarded = function () {
      if (this && this.hasAttribute && this.hasAttribute('data-cyber-form') && this.dataset.cyberReady !== 'true') {
        console.warn('[cyber] form.submit() externo ignorado até a validação terminar.');
        return;
      }
      return nativeFormSubmit.apply(this, arguments);
    };
    guarded.__cyberGuard = true;
    HTMLFormElement.prototype.submit = guarded;
  }

  // ------------------------------------------------------------------ cupom

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(area);
      ok ? resolve() : reject(new Error('copy failed'));
    });
  }

  function initCoupon(button) {
    if (!button || button.dataset.cyberInit === 'true') return;
    button.dataset.cyberInit = 'true';
    var code = button.dataset.cyberCoupon || '';
    var status = button.querySelector('[data-cyber-coupon-status]');
    var live = button.parentNode.querySelector('[data-cyber-coupon-live]');
    var label = button.dataset.label || 'Copiar';
    var copied = button.dataset.copiedLabel || '¡Copiado!';
    var timer;

    button.addEventListener('click', function () {
      copyText(code).then(function () {
        button.classList.add('is-copied');
        if (status) status.textContent = copied;
        if (live) live.textContent = copied + ' ' + code;
        clearTimeout(timer);
        timer = setTimeout(function () {
          button.classList.remove('is-copied');
          if (status) status.textContent = label;
          if (live) live.textContent = '';
        }, 2500);
      }).catch(function () {
        // Sem permissão de área de transferência: seleciona o código para cópia manual.
        var codeEl = button.querySelector('.cyber-coupon__code');
        if (codeEl && window.getSelection) {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
    });
  }

  // A tag {% form %} da Shopify grava a âncora do formulário na action
  // (/contact#CyberForm-…) e o navegador a mantém após o redirecionamento.
  // Na página de sucesso o formulário não existe: limpa a URL.
  function cleanFormHash() {
    var hash = window.location.hash || '';
    if (hash.indexOf('#CyberForm-') !== 0) return;
    if (document.getElementById(hash.slice(1))) return; // página com erro: mantém a rolagem até o form
    if (window.history && history.replaceState) {
      history.replaceState(history.state, '', window.location.pathname + window.location.search);
    }
  }

  function boot(root) {
    cleanFormHash();
    guardNativeSubmit();
    (root || document).querySelectorAll('[data-cyber-coupon]').forEach(initCoupon);
    persistUtms();
    (root || document).querySelectorAll('[data-cyber-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
